// Client-side mirror of the server's canonical pricing buckets
// (server/services/pricing-tiers.js). The server is authoritative and validates
// these bounds on every write; this copy exists so the admin pricing editor can
// label each bucket and submit a `tiers` array that matches. Keep in sync with
// the server if the MVP bucket bounds ever change (admin-defined buckets are a
// stretch goal). Bounds are [min, max) with the final bucket open-ended.

export const CUSTOM_QUOTE_MIN_SQ_MI = 50;

export const AREA_BUCKETS = Object.freeze([
  Object.freeze({ min: 50, max: 100 }),
  Object.freeze({ min: 100, max: 500 }),
  Object.freeze({ min: 500, max: 1700 }),
  Object.freeze({ min: 1700, max: null }),
]);

// Human-readable label for a bucket, e.g. "25–100" or "1,700+".
export const bucketLabel = ({ min, max }) => {
  const fmt = (n) => n.toLocaleString('en-US');
  return max == null ? `${fmt(min)}+` : `${fmt(min)}–${fmt(max)}`;
};

// A fresh tiers array (one entry per bucket) seeded with the given rate.
export const emptyTiers = (rate = 0) => AREA_BUCKETS.map((b) => ({ ...b, rate }));

// Normalize a possibly-partial/legacy tiers array to exactly the canonical
// buckets, preserving any matching rate the caller already has.
export const tiersFromRule = (tiers) => AREA_BUCKETS.map((bucket) => {
  const existing = Array.isArray(tiers)
    ? tiers.find((t) => Number(t?.min) === bucket.min && (t?.max ?? null) === bucket.max)
    : null;
  const rate = Number(existing?.rate);
  return { ...bucket, rate: Number.isFinite(rate) && rate >= 0 ? rate : 0 };
});
